<template>
  <fragment v-if="homePage">
          <b-col order="3" md="6" order-md="3" lg="4" xl="4" order-lg="2" class="custom-input-section">
            <date-input class="from"
                        label="home.form.from.label"
                        placeholder="home.form.from.placeholder"
                        name="from"
                        ref="from"
                        v-model="value.from"
                        @input="fromDateChanged"
                        :state="state"
            />
          </b-col>

          <b-col order="4" md="6" order-md="4" lg="4" xl="4" order-lg="3" class="custom-input-section">
            <date-input class="to"
                        label="home.form.to.label"
                        placeholder="home.form.to.placeholder"
                        name="to"
                        :fa-class="{ icon: 'chevron-right' }"
                        ref="to"
                        v-model="value.to"
                        @input="toDateChanged"
                        :state="state"
            />
          </b-col>
  </fragment>
  <fragment v-else>
    <div class="daterange dates" :class="{ 'custom-input' : customInput }" >
    <date-input :from-date-range="true"
                :label="from.label"
                :name="from.name"
                :submitted="submitted"
                v-model="value.from"
                ref="from"
                :custom-input="customInput"
                v-on:input="fromDateChanged"
                :state="state"
    />

    <date-input :from-date-range="true"
                :label="to.label"
                :name="to.name"
                :submitted="submitted"
                v-model="value.to"
                ref="to"
                :custom-input="customInput"
                v-on:input="toDateChanged"
                :fa-class="{ icon: 'chevron-right', solid: true }"
                :state="state"
    />

    <div v-if="amountHelpText" class="form-text text-muted">
      {{ amountHelpText + getRangeDays() }}
    </div>

    <error v-if="displayError">
        {{ errorMessage }}
    </error>
  </div>
  </fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import dateInput from '@/components/frontoffice/form/baseInput/date'
import error from '@/components/frontoffice/form/error'
import formMethods from '@/components/frontoffice/mixins/formMethods'
import dateRangeMixin from '@/components/frontoffice/mixins/dateRange'

export default {
  components: {
    dateInput,
    error,
    Fragment
  },

  mixins: [formMethods, dateRangeMixin],

  props: {
    customInput: {
      type: Boolean,
      default: true
    },
    canLastTheDay: {
      type: Boolean,
      default: false
    },
    homePage: {
      type: Boolean,
      default: false
    },
    submitted: {
      type: Boolean,
      default: false
    },
    state: {
      type: Boolean,
      default: null
    },
    amountHelpText: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      displayError: false,
      errorMessage: ''
    }
  },

  methods: {
    getRangeDays () {
      return Math.round((this.value.to - this.value.from) / (1000 * 60 * 60 * 24))
    }
  }
}
</script>

<style scoped lang="scss">
  .error {
    span {
      display: block;
    }
  }
</style>
